const availableAdyenLocales = ['de-DE', 'en-US', 'es-ES', 'fr-FR', 'ja-JP', 'zh-CN', 'zh-TW'];
export function useAdyenLocale({
  locale,
  countryCode
}) {
  if (locale === 'zh-hant') {
    return {
      translationCode: 'zh-TW'
    };
  }
  if (locale === 'zh-hans') {
    return {
      translationCode: 'zh-CN'
    };
  }
  const possibleTranslations = availableAdyenLocales.filter(str => str.includes(`${locale}-${countryCode}`) || str.includes(locale));
  if (possibleTranslations.length) {
    possibleTranslations.sort((a, b) => a.length - b.length);
    return {
      translationCode: possibleTranslations[0]
    };
  }
  return {
    translationCode: 'en-US'
  };
}